import { memo } from 'react';
import ToggleSwitch from './ToggleSwitch';

const CompactPopoverToggleContent = ({
  header = null,
  label,
  checked,
  onChange,
  disabled = false,
  description = null,
  children = null,
  inlineControl = null,
  minWidth = '180px',
  toggleCompact = false,
  ariaLabel = undefined,
}) => (
  <div className="dropdown-popover-content--compact compact-popover-toggle-content" style={{ minWidth }}>
    {header ? (
      <div className="dropdown-popover-header">{header}</div>
    ) : null}
    <div className="compact-popover-toggle-content__row">
      <span className="compact-popover-toggle-content__label">{label}</span>
      <span className="compact-popover-toggle-content__controls">
        <ToggleSwitch
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          compact={toggleCompact}
          ariaLabel={ariaLabel || label}
        />
        {inlineControl}
      </span>
    </div>
    {children ? (
      <div className="compact-popover-toggle-content__body">
        {children}
      </div>
    ) : null}
    {description ? (
      <p className="compact-popover-toggle-content__description">
        {description}
      </p>
    ) : null}
  </div>
);

export default memo(CompactPopoverToggleContent);
